import create from 'zustand';
import type { ReservationFlowStep, ReservationStore } from './types';

type ReservationFlowState = {
    step: ReservationFlowStep;
    selectedStore: ReservationStore | null;
    quantity: number;
    quantityWarningLatched: boolean;
    reservationNumber: string | null;
    chooseStore: (store: ReservationStore) => void;
    goBackToStoreList: () => void;
    setQuantity: (quantity: number) => void;
    increaseQuantity: () => void;
    decreaseQuantity: () => void;
    latchQuantityWarning: () => void;
    completeReservation: (reservationNumber: string) => void;
    reset: () => void;
};

const initialState = {
    step: 'storeList' as const,
    selectedStore: null,
    quantity: 1,
    quantityWarningLatched: false,
    reservationNumber: null,
};

export const useReservationFlowStore = create<ReservationFlowState>((set, get) => ({
    ...initialState,
    chooseStore: (selectedStore) =>
        set({
            selectedStore,
            step: 'makeReservation',
            reservationNumber: null,
            quantityWarningLatched: false,
        }),
    goBackToStoreList: () =>
        set({
            step: 'storeList',
            selectedStore: null,
            reservationNumber: null,
            quantityWarningLatched: false,
        }),
    setQuantity: (quantity) => set({ quantity }),
    increaseQuantity: () => set((state) => ({ quantity: state.quantity + 1 })),
    decreaseQuantity: () => {
        if (get().quantity > 1) set((state) => ({ quantity: state.quantity - 1 }));
    },
    // Latched by the drawer once raising the quantity actually removes a store's reserve CTA; stays
    // set until the step is left (chooseStore / goBackToStoreList / reset clear it).
    latchQuantityWarning: () => set({ quantityWarningLatched: true }),
    completeReservation: (reservationNumber) => set({ reservationNumber, step: 'success' }),
    reset: () => set(initialState),
}));
